// THE conviction label scale, everywhere (2026-11-02). Mirrors
// backend/scoring/conviction.py conviction_label() + LABEL_COLORS.
//
// Before this, grade cards, shared X cards, the conviction ring, the grade
// history chart and the screener/portfolio verdict chips used a 3-step 72/48
// scale ("Favorable 72+") while How Scores Work, the FAQ, the Glossary and the
// engine used these five, so NVDA at 72 read "Favorable" on its card and
// "Promising" in the docs. Never hard-code a cutoff: import from here.

export const LABEL_SCALE = [
  { min: 78, label: 'Favorable', cls: 'fav', color: '#22c55e' },
  { min: 72, label: 'Promising', cls: 'pro', color: '#84cc16' },
  { min: 57, label: 'Neutral', cls: 'neu', color: '#eab308' },
  { min: 48, label: 'Cautious', cls: 'cau', color: '#f97316' },
  { min: -Infinity, label: 'Unfavorable', cls: 'unf', color: '#ef4444' },
];

// Labels follow the whole number users SEE (backend scoring/conviction.py
// _displayed): labeling the raw value showed 71.6 as "72 Neutral".
export function convictionStep(score) {
  const s = Math.round(Number(score) || 0);
  return LABEL_SCALE.find((b) => s >= b.min);
}

export function convictionLabel(score) {
  return convictionStep(score).label;
}

export function convictionColor(score) {
  return convictionStep(score).color;
}

// For a label string from the backend (grade.label).
export function labelStep(label) {
  const l = String(label || '').trim().toLowerCase();
  return LABEL_SCALE.find((b) => b.label.toLowerCase() === l) || LABEL_SCALE[2];
}

// Pillar scores (Quality / Setup / Convex) are a different 60/40 read. They say
// Strong / Mixed / Weak so "Favorable" only ever means a conviction of 78+.
export function pillarStep(pct) {
  if (pct >= 60) return { cls: 'fav', word: 'Strong', color: '#2FD3A6' };
  if (pct >= 40) return { cls: 'neu', word: 'Mixed', color: '#F5B23B' };
  return { cls: 'cau', word: 'Weak', color: '#F87171' };
}
